<ng-container>
	<div
		[ngClass]="{
			shadow: view === 'summary',
		}"
		class="p-3 mb-5 bg-body rounded"
	>
		<div class="d-flex justify-content-between align-items-center fs-4 px-2">
			<label>Zadania</label>

			<button
				*ngIf="type !== TaskType.GENERAL"
				class="card__action"
				(click)="openTaskDialog(undefined, true)"
				mat-button
			>
				<i class="fas fa-plus-circle me-1"></i>
				<span> Dodaj zadanie</span>
			</button>
		</div>
		<div
			[ngClass]="{
				'w-100': view === 'summary',
				border: view === 'summary',
				rounded: view === 'summary',
			}"
		>
			<div *ngFor="let item of service.data">
				<div *ngIf="view === 'summary' && !item.completed" class="bg-task m-2 rounded px-3 py-2">
					<div class="border-bottom border-2">
						<p class="my-1">{{ item.content }}</p>
					</div>
					<div class="d-flex mb-1 mt-2 align-items-center">
						<div class="d-flex flex-column w-75 text-secondary">
							<div class="me-3">Status: {{ item.status.name }}</div>
							<div>
								Rodzaj:
								<span *ngFor="let kind of item.kinds; index as i">
									{{ kind.name
									}}<span *ngIf="item.kinds.length > 1 && item.kinds.length !== i + 1">, </span>
								</span>
							</div>
							<div>
								Termin:
								<i class="fas fa-clock ms-2 me-1"></i>
								{{ item.deadline | date: 'dd.MM.yyyy | HH:mm' }}
							</div>
							<div>
								Przypisane dla:
								<span *ngFor="let user of item.users; index as i">
									{{ user.firstName }} {{ user.lastName }},
								</span>
								<span *ngFor="let department of item.responsibilityDepartments; index as i">
									{{ department.kind.name }},
								</span>
							</div>
							<div>
								Utworzone: {{ item.createdBy.firstName }}
								{{ item.createdBy.lastName }}
								<i class="fas fa-clock ms-2 me-1"></i>
								{{ item.createdAt | date: 'dd.MM.yyyy | HH:mm' }}
							</div>
						</div>
						<div class="w-25 text-end">
							<button
								(click)="openTaskDialog(item.id, true)"
								class="mb-2 w-x"
								mat-raised-button
								color="primary"
							>
								Edytuj
							</button>
							<button (click)="endTask(item)" class="w-x" mat-raised-button color="primary">
								Zakończ
							</button>
						</div>
					</div>
				</div>
			</div>
			<table
				#dataTable
				*ngIf="view === 'tab'"
				mat-table
				matSort
				[dataSource]="service.dataSource"
				class="mat-elevation-z8 w-100"
			>
				<ng-container matColumnDef="created">
					<th mat-sort-header mat-header-cell *matHeaderCellDef>Utworzono</th>
					<td mat-cell *matCellDef="let element">
						{{ element.createdAt | date: 'dd.MM.yyyy | HH:mm' }}<br />
						{{ element.createdBy.firstName }}
						{{ element.createdBy.lastName }}
					</td>
				</ng-container>

				<ng-container matColumnDef="completed">
					<th mat-sort-header mat-header-cell *matHeaderCellDef>Zakończono</th>
					<td mat-cell *matCellDef="let element">
						{{ element.completed | date: 'dd.MM.yyyy | HH:mm' }}
						{{ element.completedBy?.firstName }}
						{{ element.completedBy?.lastName }}
					</td>
				</ng-container>

				<ng-container matColumnDef="users">
					<th mat-header-cell *matHeaderCellDef>Przypisano</th>
					<td mat-cell *matCellDef="let element">
						<span *ngFor="let user of element.users; index as i">
							{{ user.firstName }} {{ user.lastName }},
						</span>
						<span *ngFor="let department of element.responsibilityDepartments; index as i">
							{{ department.kind.name }},
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-sort-header mat-header-cell *matHeaderCellDef>Status</th>
					<td mat-cell *matCellDef="let element">
						{{ element.status.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="content">
					<th mat-sort-header mat-header-cell *matHeaderCellDef>Treść</th>
					<td mat-cell *matCellDef="let element">
						{{ element.content }}
					</td>
				</ng-container>

				<ng-container matColumnDef="notes">
					<th mat-sort-header mat-header-cell *matHeaderCellDef>Notatki</th>
					<td mat-cell *matCellDef="let element">
						{{ element.notesCount }}
					</td>
				</ng-container>

				<ng-container matColumnDef="edit">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let element">
						<button
							*ngIf="!element.completed"
							(click)="openTaskDialog(element.id, true)"
							class="w-x"
							mat-raised-button
							color="primary"
						>
							Edytuj
						</button>
						<button
							*ngIf="element.completed"
							(click)="openTaskDialog(element.id, false)"
							class="w-x"
							mat-raised-button
							color="primary"
						>
							Podgląd
						</button>
					</td>
				</ng-container>

				<ng-container matColumnDef="end">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let element">
						<button
							*ngIf="!element.completed && type !== TaskType.GENERAL"
							(click)="endTask(element)"
							class="w-x"
							mat-raised-button
							color="primary"
						>
							Zakończ
						</button>
						<i *ngIf="element.completed" class="fas fa-check-circle text-success fs-4"></i>
					</td>
				</ng-container>

				<ng-container matColumnDef="link">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let element">
						<button
							mat-raised-button
							color="primary"
							*ngIf="element.tableName === TableName.RESERVATION && type === TaskType.GENERAL"
							(click)="openReservationInNewTab(element)"
						>
							Przejdź <i class="fas fa-angle-double-right"></i>
						</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
			<mat-paginator
				*ngIf="type === TaskType.GENERAL"
				class="mat-elevation-z4 d-flex justify-content-start"
				[pageSizeOptions]="[10, 20, 30]"
			>
			</mat-paginator>
		</div>
	</div>
</ng-container>
